import token, { tokenToVars } from '../token';
import Tag from './tag';

export { Tag };
export default tokenToVars(Tag, token);
